import render from './render-mustache.js';
import ToastComponent from './ToastComponent.js';

export const Dishes = (container, props) => {
    const dishes = Array.from(props.getBranchDishes(Math.floor(props.branchID)));

    // Generate an array with numbers from 1 to dishes.length
    const numbers = Array.from({ length: dishes.length }, (_, i) => i + 1);
    
    // Shuffle the array to make the numbers unique and random
    for (let i = numbers.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
    }
    numbers.forEach((number, i) => dishes[i].image =  `./${number}.jpg`);

    if (!dishes || !dishes.length) {
        ToastComponent(container, { message: "No MENU available yet!!" });
        return;
    } else {
        const template = `
            <div class="row mb-2">
                {{#dishes}}
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                        <div class="card shadow d-flex flex-column h-100">
                            <img class="card-img-top" style="object-fit: cover; height: 10rem;" src="{{image}}" alt="Card image cap">
                            <div class="card-body py-1 flex-grow-1">
                                <h5 class="card-title">{{item_name}} @ <span class="text-danger">R{{price}}</span></h5>
                            </div>
                            {{#isIngredients}}
                                <hr class="my-1">
                                <div class="ml-4"><b>Ingridiensts:</b></div>
                                <span class="ml-4 pb-1">{{#ingredients}}<small>{{.}}, </small>{{/ingredients}}</span>
                            {{/isIngredients}}
                        </div>
                    </div>
                {{/dishes}}
            </div>
        `;
        render(container, 'innerHTML', template, { dishes });
    }
}

export default Dishes;